export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x7949bE8B154D7B5ce6E75cBfc646AeF3a25970E2",
  eulerSwapV1Implementation: "0x04671F895c7d9EAbF33FF1dfF41269E6Fea835D1",
  eulerSwapV1Periphery: "0x804485f5B6c293f8d63f697E9662CD4a8765858A",
} as const
